import { defineComponent as _defineComponent } from 'vue'
import { useVModel } from '@vueuse/core';
import $ from 'jquery';
import {
    computed, shallowRef, unref, watch,
} from 'vue';

import { useJqueryEventListener } from '#public_ts/composables';
import type { JqueryEventListener } from '#public_ts/composables/jquery-events';


export default /*#__PURE__*/_defineComponent({
  __name: 'yes-no-check',
  props: {
    name: null,
    id: null,
    on: null,
    off: null,
    modelValue: null,
    booleanValue: { type: Boolean }
  },
  emits: ["update:modelValue", "update:booleanValue"],
  setup(__props: any, { emit }: { emit: ({
    (event: 'update:modelValue', value: string): void;
    (event: 'update:booleanValue', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    name?: string;
    id?: string;
    on?: string;
    off?: string;
    modelValue?: string;
    booleanValue?: boolean;
}


//eslint-disable-next-line no-spaced-func

const selectedRadio = useVModel(props, 'booleanValue', emit, { passive: true });
const _on = computed(() => props.on || 'on');
const _off = computed(() => props.off || '');
const buttonGroupElement = shallowRef<HTMLElement | undefined>();

function updateValue(useStringValue?: boolean) {
    //synchronize initially and on the go
    //initial setup
    //if model value is provided - prefer it
    //if boolean value is not provided - default to false
    let stringValue = props.modelValue;
    if(((stringValue !== undefined) || (useStringValue === true)) && (useStringValue !== false)) {
        const value = (String(stringValue) === unref(_on));
        if(value !== unref(selectedRadio)) {
            selectedRadio.value = value;
        }
    } else {
        //order is important, first we set modelValue, then booleanValue
        //in this case we can catch when modelValue === undefined and booleanValue === undefined
        stringValue = unref(selectedRadio) ? unref(_on) : unref(_off);
        if(stringValue !== props.modelValue) {
            emit('update:modelValue', stringValue);
        }
    }
}

watch(() => props.modelValue, () => {
    updateValue(true);
});

watch(selectedRadio, () => {
    updateValue(false);
});

updateValue();

//v-model doesn't work here, because user actually clicks on label, and bootstrap manages everything
//bootstrap sends if (changed) $input.trigger('change'); which is not handled by vue
//just 'change' don't work, sometimes bootstrap skips this event, don't know why
const onChange: JqueryEventListener = function(event) {
    let radio = $((event as JQuery.TriggeredEvent).target);
    if(!radio.is('input')) {
        radio = radio.find('input');
    }
    selectedRadio.value = radio.val() === unref(_on);
};
useJqueryEventListener(buttonGroupElement, ['change', 'click'], onChange);

return { __sfc: true,props, emit, selectedRadio, _on, _off, buttonGroupElement, updateValue, onChange }
}

})